//import './styles.css';
import Card from '../Card';
import React from 'react';
import { $state, $stateParams } from '../../router';
import RsvpService from '../../services/RsvpService';
import Utils from '../../services/utils/utils';
import {__, STR_KEY} from '../../services/Translate';
import {
    GeckoBtn,
    GeckoToastService,
    GeckoDialogService
} from '@geckolabs/gecko-react-ui';

const cancelFn = (eventId) => {
    
    const message = __(STR_KEY.MODAL_CANCEL_CONTENT);
    const params = {
        size: 'md',
        btns: {
            confirm: {label: __(STR_KEY.MODAL_CANCEL_BTN_YES), type: 'danger'},
            decline: {label: __(STR_KEY.MODAL_CANCEL_BTN_NO)}
        }
    };

    new GeckoDialogService().confirm(message, params).then(confirm => {
        if (confirm) {
            new RsvpService().updateAttendance(eventId, 'no').then((rsvpData) => {            
                new GeckoToastService().success(__(STR_KEY.MODAL_CANCEL_TOAST));

                $state.go($state.$current.name, $stateParams, {reload: true});

            }).catch(err => new GeckoToastService().error(err));
            return;
        } 
    });
};

const CancelBtn = ({eventAttendance}) => {

    if ([30, 40, 90, 100].includes(eventAttendance.status)) return null;
    
    return (
        <Card className="cancel-btn-container">
            <GeckoBtn 
                id="cancel-top-level"
                type={'danger'}
                name={__(STR_KEY.BTN_CANCEL)}
                icon={'ban'}
                handler={cancelFn.bind(this, eventAttendance.event_id)} />
        </Card>
    );
};

export default CancelBtn;